export const tableStyle = {
  paperContainerTable: {
    maxWidth: '80rem',
    margin: { xs: '-1vh auto 0', sm: '0 auto -9.7vh' },
    padding: { xs: '1rem 1rem .75rem', lg: '2rem 2rem 1.5rem' },
    borderRadius: '8px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'
  },
  containerFilters: {
    display:'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    marginBottom: '1rem',
    gap: '.5rem'
  },
  inputLabelFilters: {
    padding: '0 0 .2rem .35rem',
    fontSize: '0.9rem',
    lineHeight: '1.25rem'
  },
  textField: {
    borderRadius: '6px',

    '& input': { padding: '.5rem .5rem .5rem 1rem' },
    '&:hover': { borderColor: (theme) => theme.palette.background.default },
    '&:focus-visible': { borderColor: (theme) => theme.palette.secondary.main }
  },
  dateField: {
    zIndex: '5',

    '& input': {
      padding: '.5rem 0 .5rem 1rem',
      marginRight: '-2rem',
      zIndex: '10'
    },
    '& input[type="date"]::-webkit-calendar-picker-indicator': {
      background: 'transparent'
    }
  },
  containerTable: { maxHeight: 'calc(100vh - 24rem)' },
  table: { minWidth: '100%' },
  tableHead: {
    top: '0',
    position: 'sticky',
    backgroundColor: '#f9fafb',
    zIndex: '10000000',

    '& tr th': {
      minWidth: '100px',
      padding: '0.6rem 1rem',
      fontSize: '0.75rem',
      lineHeight: '1rem',
      color: '#6b7280',
      textTransform: 'uppercase',
      letterSpacing: '0.05em'
    }
  },
  tableCell: {
    padding: '1rem 1.5rem',
    lineHeight: '1.25rem'
  },
  tableCellButton: {
    padding: '0.375rem 0.75rem',
    backgroundColor: (theme) => theme.palette.background.default,
    borderRadius: '6px',
    fontSize: '0.75rem',
    textTransform: 'none',
    color: '#130B1F',

    '&:hover': {
      backgroundColor: (theme) => theme.palette.secondary.main,
      color: 'white'
    }
  },
  containerPagination: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    justifyContent: 'space-between',
    padding: '1rem 0 0',
    gap: '1rem',

    '& .MuiTypography-root': {
      fontSize: '.875rem',
      color: '#374151'
    },

    '& .MuiPagination-ul': {
      '& .MuiPaginationItem-outlined': {
        alignItems: 'center',
        margin: '0 1px',
        padding: '.5rem .75rem',
        backgroundColor: 'white',
        border: '1px solid #d1d5db',
        borderRadius: '6px',
        lineHeight: '1.25rem',
        fontWeight: '500',
        color: '#374151',

        '&.MuiPaginationItem-ellipsis': { padding: '.31rem .75rem' },

        '&.Mui-selected': {
          backgroundColor: '#eef2ff',
          borderColor: (theme) => theme.palette.background.default,
          color: (theme) => theme.palette.secondary.main,
          pointerEvents: 'none',

          '&:hover': {
            backgroundColor: '#eef2ff',
            borderColor: (theme) => theme.palette.background.default,
            color: (theme) => theme.palette.secondary.main
          }
        },

        '&:hover': { backgroundColor: '#f9fafb' },
        '&:disabled': { opacity: '.5' }
      }
    }
  }
}
